import type { QueryClient } from "@tanstack/react-query";

/** Refetches every tasks list on the page, whatever its filters, e.g. after a task changes. */
export const invalidateTasks = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({ predicate: (query) => (query.queryKey[0] as { _id?: string } | undefined)?._id === "tasksList" });
